
const tableList = [

    {
        entityField: "bgmName",
        showField: "通用名称",
        fieldWeight: 200,
        fieldType: "string",
        riftField: "bgmId",
        fixed: 'left',
    },
    {
        entityField: "spmc",
        showField: "商品名称",
        fieldWeight: 130,
        fieldType: "string",
        riftField: "bgmId",
        fixed: 'left',
    },
    {
        entityField: "mne",
        showField: "助记码",
        fieldWeight: 130,
        fieldType: "string",
        riftField: "bgmId",
        fixed: 'left',
    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 130,
        fieldType: "string",
        riftField: "bgmId",
        fixed: 'left',
    },
    {
        entityField: "packingSpec",
        showField: "装箱规格",
        fieldWeight: 130,
        fieldType: "string",
        riftField: "bgmId",
        fixed: 'left',
    },
    {
        entityField: "manufacturer",
        showField: "生产商",
        fieldWeight: 120,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "minUdi",
        showField: "最小销售单元产品标识",
        fieldWeight: 180,
        fieldType: "string",
        fixed: 'left',
    },
   
    {
        entityField: "bgiRegistno",
        showField: "注册证编号或者备案凭证编号",
        fieldWeight: 180,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "bgiStocondition",
        showField: "存储类型",
        fieldWeight: 120,
        fieldType: "string",
        fixed: 'left',
    },

    {
        entityField: "bgpUnitmeasurement",
        showField: "包装单位",
        fieldWeight: 90,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "classifCode",
        showField: "分类编码",
        fieldWeight: 140,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "cpbh",
        showField: "产品编码",
        fieldWeight: 140,
        fieldType: "string",
        fixed: 'left',
    },

    {
        entityField: "cpbsfbrq",
        showField: "标识发布时间",
        fieldWeight: 100,
        fieldType: "time",
        fixed: 'left',
    },
    {
        entityField: "createTime",
        showField: "创建时间",
        fieldWeight: 100,
        fieldType: "time",
        fixed: 'left',
    },
    {
        entityField: "deviceCate",
        showField: "器械类别",
        fieldWeight: 70,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "medicalCode",
        showField: "医保耗材分类编码",
        fieldWeight: 120,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "picsName",
        showField: "产品标识编码体系名称",
        fieldWeight: 180,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "productCate",
        showField: "产品类别",
        fieldWeight: 120,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "registName",
        showField: "医疗器械注册人/备案人名称",
        fieldWeight: 220,
        fieldType: "string",
        fixed: 'left',
    },
    {
        entityField: "udi",
        showField: "使用单元产品标识",
        fieldWeight: 120,
        fieldType: "string",
        fixed: 'left',
    },
]
export default tableList
